import { css } from "../../../styled-system/css";

const desktopGridColumns = "minmax(0, 1fr) 200px 200px 96px";

const iconButtonStyles = {
  flexShrink: 0,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: "baseUnit.mobile3",
  height: "baseUnit.mobile3",
  padding: 0,
  borderRadius: 0,
  color: "headlineGrey",
  _disabled: {
    opacity: 0.3,
    cursor: "not-allowed",
  },
  "& svg": {
    width: "baseUnit.mobile3",
    height: "baseUnit.mobile3",
  },
} as const;

export const styles = {
  card: () =>
    css({
      backgroundColor: "white",
      borderRadius: "baseUnit.mobile1",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "disabledGrey",
      boxShadow: "softBottomRight",
      display: "grid",
      gridTemplateColumns: "minmax(0, 1fr) auto",
      gridTemplateAreas: '"user actions" "badges badges"',
      columnGap: "baseUnit.mobile2",
      rowGap: "baseUnit.mobile1",
      alignItems: "center",
      padding: "baseUnit.mobile2",
      width: "100%",
      desktop: {
        backgroundColor: "transparent",
        borderRadius: 0,
        borderWidth: 0,
        boxShadow: "none",
        gridTemplateColumns: desktopGridColumns,
        gridTemplateAreas: '"user status role actions"',
        gap: "baseUnit.mobile2",
        padding: 0,
        paddingLeft: "baseUnit.mobile3",
        paddingRight: "baseUnit.mobile3",
        minHeight: "76px",
        borderBottomWidth: "1px",
        borderBottomStyle: "solid",
        borderBottomColor: "paleBlueLight",
        _last: {
          borderBottomWidth: 0,
        },
      },
    }),
  userCell: () =>
    css({
      gridArea: "user",
      display: "flex",
      flexDirection: "column",
      minWidth: 0,
    }),
  email: () =>
    css({
      fontSize: "body.horse",
      fontWeight: 700,
      lineHeight: "body.horse",
      letterSpacing: "body.horse",
      color: "headlineGrey",
      margin: 0,
      wordBreak: "break-word",
      desktop: {
        fontSize: "body.shrimp",
        fontWeight: 400,
        lineHeight: "20px",
        letterSpacing: "body.shrimp",
      },
    }),
  name: () =>
    css({
      fontSize: "body.mouse",
      fontWeight: 400,
      lineHeight: "baseUnit.mobile2",
      letterSpacing: "0.25px",
      color: "stdTextGrey",
      margin: 0,
      marginTop: "2px",
      wordBreak: "break-word",
      desktop: {
        fontSize: "body.butterfly",
      },
    }),
  statusCell: () =>
    css({
      gridArea: "badges",
      display: "flex",
      alignItems: "center",
      gap: "baseUnit.mobile1",
      desktop: {
        gridArea: "status",
        flexDirection: "column",
        alignItems: "flex-start",
      },
    }),
  roleCell: () =>
    css({
      display: "none",
      desktop: {
        display: "flex",
        gridArea: "role",
        alignItems: "center",
      },
    }),
  roleBadgeMobile: () =>
    css({
      desktop: {
        display: "none",
      },
    }),
  statusLabel: (variant: "default" | "success" | "info") =>
    css({
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      paddingTop: "4px",
      paddingBottom: "4px",
      paddingLeft: "baseUnit.mobile1",
      paddingRight: "baseUnit.mobile1",
      borderRadius: "100px",
      fontSize: "body.butterfly",
      lineHeight: "body.butterfly",
      letterSpacing: "body.butterfly",
      fontWeight: 700,
      textTransform: "uppercase",
      whiteSpace: "nowrap",
      backgroundColor:
        variant === "success"
          ? "darkGreen.transparent"
          : variant === "info"
            ? "babyBlue.transparent"
            : "backgroundGrey",
      color: variant === "success" ? "darkGreen" : variant === "info" ? "blue" : "black",
    }),
  resendLink: () =>
    css({
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
      padding: 0,
      background: "transparent",
      border: "none",
      cursor: "pointer",
      fontWeight: 700,
      fontSize: "14px",
      lineHeight: "18px",
      letterSpacing: "1px",
      color: "facebookShareBlue",
      "& svg": {
        width: "baseUnit.mobile2",
        height: "baseUnit.mobile2",
      },
    }),
  actionsCell: () =>
    css({
      gridArea: "actions",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: "baseUnit.mobile2",
      flexShrink: 0,
    }),
  iconButton: () => css(iconButtonStyles),
  editButton: () =>
    css(iconButtonStyles, {
      // Hidden on mobile — edit is offered via the 3-dots action modal instead.
      display: "none",
      desktop: {
        display: "inline-flex",
      },
    }),
  menuWrapper: () =>
    css({
      position: "relative",
      display: "inline-flex",
    }),
  menuDropdown: () =>
    css({
      display: "none",
      desktop: {
        position: "absolute",
        top: "calc(100% + token(spacing.baseUnit.mobile1))",
        right: 0,
        zIndex: 10,
        minWidth: "180px",
        backgroundColor: "white",
        borderRadius: "baseUnit.mobile1",
        boxShadow: "softBottomRight",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "disabledGrey",
        padding: "baseUnit.mobile1",
        display: "block",
      },
    }),
  menuItem: () =>
    css({
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "baseUnit.mobile1",
      width: "100%",
      whiteSpace: "nowrap",
    }),
  menuItemIcon: () =>
    css({
      width: "18px",
      height: "18px",
      flexShrink: 0,
    }),
  desktopGridColumns,
};
